import Trans from '../components/translations/trans';
import currencyFormatter from './currencyFormatter';

/**
 * Check if there are multiple offers so we need to show an 'up to ...' on the label
 * @param {String} offers
 */
export const getPromoLabelPrefix = (offers, highestOffer): string => {
    let variablePercentage = false;

    Object.keys(offers).forEach((articleType) => {
        const articleTypeOffers = Array.isArray(offers[articleType]) ? offers[articleType] : [offers[articleType]];
        const highestOfferForArticleType = articleTypeOffers[articleTypeOffers.length - 1];

        if (highestOfferForArticleType !== highestOffer) {
            variablePercentage = true;
        }
    });

    return variablePercentage ? 'product.discount.upToPrefix' : '';
};

/**
 * Get the prices, strikethrough and discounted price, for now we only support percentage discounts
 * @param {Object} offers
 * @param {Object} productInfo
 *
 * @returns {Object}
 */
export const getPrices = (offers) => {
    let strikeThroughPrice, discountedPrice, discountLabel, isLowest30DaysPrice;
    Object.keys(offers).forEach((articleType) => {
        strikeThroughPrice = offers[articleType]?.['discount']?.['formatted_reference_price'];
        discountedPrice = offers[articleType]?.['discount']?.['formatted_reference_discount_price'];
        discountLabel = offers[articleType]?.['discount']?.['reference_discount_label'];
        isLowest30DaysPrice = offers[articleType]?.['discount']?.['is_lowest_30days_price'];
    });
    return { strikeThroughPrice, discountedPrice, discountLabel, isLowest30DaysPrice };
};

/**
 *
 * @param {Object} promotion
 * @return {String}
 */
export const getUspMarkup = (promotion) => {
    let translationArticleTypeKey =
        Object.keys(promotion.offers).length === 1 ? Object.keys(promotion.offers)[0] : 'walldecor';
    translationArticleTypeKey = translationArticleTypeKey.toLowerCase();

    return (
        <ul class='usp-list arc3-typo-checklist arc3-no-padding--left --dark-grey'>
            <li>
                <Trans transKey={`product.${translationArticleTypeKey}.usp1.title`} />
            </li>
            <li>
                <Trans transKey={`product.${translationArticleTypeKey}.usp2.title`} />
            </li>
            <li>
                <Trans transKey={`product.${translationArticleTypeKey}.usp3.title`} />
            </li>
        </ul>
    );
};
